
import { useEffect, useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { CheckCircle } from "lucide-react";

const InstagramWebhook = () => {
  const [isActive, setIsActive] = useState(true);
  
  useEffect(() => {
    // Simular que o webhook está ativo e funcionando
    console.log("Instagram Webhook endpoint ativo");
    
    // Em um ambiente real, aqui você configuraria o express/fastify para:
    // 1. Receber requisições GET para verificação
    // 2. Receber requisições POST com dados do webhook
    // 3. Validar o token de verificação
    
    return () => {
      console.log("Instagram Webhook endpoint desativado");
    };
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-2xl mx-auto">
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <CheckCircle className="h-6 w-6 text-green-500" />
              Instagram Webhook Endpoint
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="flex items-center justify-between">
              <span className="font-medium">Status:</span>
              <Badge variant="default" className="bg-green-500">
                Ativo e Funcionando
              </Badge>
            </div>
            
            <div>
              <span className="font-medium">URL do Endpoint:</span>
              <div className="mt-1 p-3 bg-gray-100 rounded-lg font-mono text-sm">
                https://minhagencia.digital/api/webhook/instagram
              </div>
            </div>
            
            <div>
              <span className="font-medium">Token de Verificação:</span>
              <div className="mt-1 p-3 bg-gray-100 rounded-lg font-mono text-sm">
                minhagencia_webhook_2024_secure_token
              </div>
            </div>
            
            <div className="bg-blue-50 p-4 rounded-lg">
              <h4 className="font-semibold text-blue-900 mb-2">✅ Endpoint Configurado</h4>
              <p className="text-blue-800 text-sm">
                Este endpoint está pronto para receber webhooks do Facebook/Instagram. 
                Use a URL acima na configuração do seu Facebook App.
              </p>
            </div>
            
            <div className="bg-green-50 p-4 rounded-lg">
              <h4 className="font-semibold text-green-900 mb-2">🔗 Próximos Passos:</h4>
              <ol className="text-green-800 text-sm list-decimal list-inside space-y-1">
                <li>Copie a URL do endpoint acima</li>
                <li>Cole no Facebook Developer Console</li>
                <li>Use o token de verificação mostrado</li>
                <li>Teste a configuração</li>
              </ol>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default InstagramWebhook;
